import { render, staticRenderFns } from "./CoursesOfUser.vue?vue&type=template&id=38225594&scoped=true&"
import script from "./CoursesOfUser.vue?vue&type=script&lang=js&"
export * from "./CoursesOfUser.vue?vue&type=script&lang=js&"
import style0 from "./CoursesOfUser.vue?vue&type=style&index=0&id=38225594&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38225594",
  null
  
)

export default component.exports